import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, apiError, mediaUrl } from "../../lib/api";

export const ImageField = ({ value, onChange, testId }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/media", fd);
      onChange(data.url);
      toast.success("Immagine caricata");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex items-center gap-3">
      <div className="w-24 h-16 rounded-lg overflow-hidden border hairline bg-white/5 shrink-0">
        {value ? <img src={mediaUrl(value)} alt="" className="w-full h-full object-cover" /> : null}
      </div>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files?.[0])} />
      <button type="button" data-testid={testId} onClick={() => ref.current?.click()}
        className="h-9 px-3 rounded-lg border hairline text-sm text-white inline-flex items-center gap-2 hover:bg-white/5">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}Carica
      </button>
      {value && (
        <button type="button" onClick={() => onChange("")} className="h-9 w-9 grid place-items-center rounded-lg text-slate-400 hover:text-white" aria-label="Rimuovi immagine">
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};
